<template>
  <div class="error-404-container">
    <div class="error-content">
      <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
        <defs>
          <linearGradient id="9nqeuf3e3a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DFE5F4"/>
            <stop offset="100%" stop-color="#F6F9FF"/>
          </linearGradient>
          <linearGradient id="2clfvkgpcb" x1="50%" x2="50%" y1="0%" y2="99.691%">
            <stop offset="0%" stop-color="#F9F9FA"/>
            <stop offset="100%" stop-color="#D3D6DC"/>
          </linearGradient>
          <linearGradient id="npiblfxa0c" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#C3C7CF"/>
            <stop offset="100%" stop-color="#DFE1E5"/>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g>
            <g>
              <g>
                <path d="M0 0H200V200H0z" transform="translate(-620.000000, -340.000000) translate(574.000000, 340.000000) translate(46.000000, 0.000000)"/>
                <g transform="translate(-620.000000, -340.000000) translate(574.000000, 340.000000) translate(46.000000, 0.000000) translate(9.000000, 31.000000)">
                  <ellipse cx="84" cy="125.5" fill="url(#9nqeuf3e3a)" opacity=".537" rx="84" ry="13.5"/>
                  <path fill="#C7CCD6" d="M21.047 23.5h127.901c5.523 0 10 4.477 10 10v.051l-.422 82c-.028 5.503-4.497 9.949-10 9.949H21.436c-5.505 0-9.974-4.448-10-9.953l-.388-82C11.02 28.025 15.478 23.527 21 23.5h.047z"/>
                  <rect width="148" height="102" x="11" y="23" fill="url(#2clfvkgpcb)" rx="10"/>
                  <path fill="url(#npiblfxa0c)" d="M153 23c3.314 0 6 2.686 6 6v10H11V29c0-3.314 2.687-6 6-6h136z"/>
                  <circle cx="19" cy="31" r="3" fill="#F5F9FC"/>
                  <circle cx="27.036" cy="31" r="3" fill="#F5F9FC"/>
                  <circle cx="35.071" cy="31" r="3" fill="#F5F9FC" opacity=".8"/>
                  <g transform="translate(58.000000, 43.000000)">
                    <circle cx="29.5" cy="29.5" r="29.5" fill="#9CA4B2" opacity=".562"/>
                    <circle cx="29" cy="30" r="24" fill="#9CA4B2"/>
                    <path fill="#E1E6EA" d="M19.846 15.615L29 24.77l9.154-9.154c1.444-1.444 3.786-1.444 5.23 0 1.445 1.445 1.445 3.787 0 5.231L34.232 30l9.154 9.154c1.444 1.444 1.444 3.786 0 5.23-1.445 1.445-3.787 1.445-5.231 0L29 35.232l-9.154 9.154c-1.444 1.444-3.786 1.444-5.23 0-1.445-1.445-1.445-3.787 0-5.231L23.768 30l-9.154-9.154c-1.444-1.444-1.444-3.786 0-5.23 1.445-1.445 3.787-1.445 5.231 0z"/>
                  </g>
                  <rect width="72" height="6" x="51" y="105" fill="#9CA4B2" opacity=".832" rx="3"/>
                  <circle cx="176.5" cy="82.5" r="6.5" fill="#F4F7FE"/>
                  <circle cx="34" cy="7" r="7" fill="#F4F7FE"/>
                  <circle cx="48.5" cy="16.5" r="3.5" fill="#F4F7FE"/>
                  <circle cx="4.5" cy="91.5" r="4.5" fill="#F4F7FE"/>
                  <circle cx="164" cy="88" r="3" fill="#F4F7FE"/>
                  <circle cx="168.5" cy="37.5" r="6.5" fill="#F4F7FE"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <p class="title">{{ showTitle }}</p>
      <router-link to="/" class="link">Go to Main Page</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTitle: 'This page no longer exists.'
    }
  },
  created() {
    if(this.$route.query.type === 'driverDetails') {
      this.showTitle = this.$route.query.text;
    }
  }
}
</script>
<style lang="scss" scoped>
.error-404-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  .error-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #7f8596;
    }
    .link {
      display: inline-block;
      margin-top: 10px;
      font-weight: 500;
      font-size: 16px;
      color: #4066d4;
    }
  }
}
</style>
